// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Y_z7d","footerContainer":"Footer_footerContainer__qWaYJ","link":"Footer_link__21ETI"};